module.exports = __webpack_public_path__ + "img/ic_prersonal_info.f31888a2.svg";